import '../Sidebar/Sidebar.css';
// import Style from '../Sidebar/Sidebar.css';
import Navtab2 from '../Navbar/Navtab2';
// import Navtab2 from '../Navbar/Navtab2';
// import Navtab3 from '../Navbar/Navtab3';


// const performActionBasedOnDropdownId = (dropdownId) => {
//   // Uncomment and modify this logic as needed
//   // let message = '';

//   if (dropdownId === 'digitalAgricultureDropdown') {
//     // message = 'Hello, we are in Navtab1';
//     return <Navtab1 />;
//   }

//   return null; // Or return an empty element or default content if needed
// };


export default function Sidebar(){

    return(

        <>
        <div className="d-flex flex-column flex-shrink-0 p-3 custom-font-size bg-light" style={{height:'100vh' }}>
    <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none">
      <span className="fs-5">Section</span>
    </a>
    <hr/>
    <ul className="nav nav-pills flex-column mb-auto">

    <div className="fs-6 bg-success">
    <Navtab2/>
    </div>

</ul>
    <hr/>
    
  </div>
  </>
        
    )
};